import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { IJourney } from '@/modules/journey/model';
import { renderEvent } from '@/shared/utils/renderEvent';
import { DescriptionList } from '@/shared/view/DescriptionList';

import s from './styles.module.css';

const History = ({ journey }: { journey: IJourney }) => {
  const intl = useIntl();

  const titles = useMemo(
    (): [string, string][] =>
      (journey.events || []).map(event => [event.name, renderEvent(event.name, intl)]),
    [journey.events, intl],
  );

  const values = useMemo(
    () =>
      (journey.events || []).reduce(
        (eventValues, event) => {
          eventValues[event.name] = intl.formatDate(event.date, {
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            timeZone: journey.timezone,
          });

          return eventValues;
        },
        {} as Record<string, string>,
      ),
    [journey.events, journey.timezone, intl],
  );

  return (
    <DescriptionList
      title={intl.formatMessage({
        defaultMessage: 'History',
        id: 'w/dzZd',
        description: 'Journey screen: History section title',
      })}
      titles={titles}
      values={values}
      className={s.details}
    />
  );
};

export { History };
